"use client";

import React from "react";
import type { ProjectName } from "@/app/projects/types";
import Container from "@/components/ui/layout/container";
import Section from "@/components/ui/layout/section";
import GalleryCard from "../GalleryCard";

const SECTION_ID = "project-gallery";

interface ProjectsGallerySectionProperties {
  projectName: ProjectName;
}

function ProjectsGallerySection({
  projectName,
}: ProjectsGallerySectionProperties) {
  return (
    <Section id={SECTION_ID}>
      <Container id={SECTION_ID} maxWidth="max-w-5xl">
        <GalleryCard
          projectName={projectName}
          title={projectName}
          description="Stunning Interior & Exterior photos"
          sub="GALLERY"
          showCTA={false}
        />
      </Container>
    </Section>
  );
}

export default ProjectsGallerySection;
